import { Component } from '@angular/core';
import { LandingHeaderComponent } from '../../../features/landing/landing-header/landing-header.component';
import { LandingFooterComponent } from '../../../features/landing/landing-footer/landing-footer.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-landing-layout',
  standalone: true,
  imports: [LandingHeaderComponent, LandingFooterComponent, RouterOutlet],
  templateUrl: './landing-layout.component.html',
  styles: ``
})
export class LandingLayoutComponent {}
